import firebase from "firebase/app";
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyC5-oWU4I7C7QRlTjVrNgtJj_41CvZeav4",
  authDomain: "portfolio-5e297.firebaseapp.com",
  projectId: "portfolio-5e297",
  storageBucket: "portfolio-5e297.appspot.com",
  messagingSenderId: "858250175422",
  appId: "1:858250175422:web:7d77bc1ba3cf51824ccfef"
};

//init firebase
firebase.initializeApp(firebaseConfig)
firebase.firestore().settings({ experimentalForceLongPolling: true });

//init services
const projectFirestore = firebase.firestore();

export { projectFirestore }